export default __webpack_public_path__ + "static/media/Purple-BG-Start.ceb4471b.svg";